import React, { Component } from 'react'
import './ShareGroup.css'
import { ControlInput } from '../commons/Controls'
import { BtnPrimary } from '../commons/Buttons'

class ShareGroup extends Component {
  render () {
    const url = 'www.st4dium.com/invite/' + this.props.groupId
    return (
      <div className='share-group'>
        <p>Comparte esta liga para que tus amigos se unan al grupo.</p>
        <div className='share-group__section'>
          <ControlInput
            type='text'
            label='Enlace'
            value={url}
            readOnly
          />
        </div>
        <div className='share-group__section'>
          <h3>Enviar por</h3>
          <a href={'https://api.whatsapp.com/send?text=' + url} className='share-group__btn' target='_blank'>WhatsApp</a>
          <a href={'https://www.facebook.com/sharer/sharer.php?u=' + url} className='share-group__btn' target='_blank'>Facebook</a>
          <a href={'https://twitter.com/intent/tweet?text=' + url} className='share-group__btn' target='_blank'>Twitter</a>
        </div>
        <div className='share-group__footer'>
          <BtnPrimary onClick={() => this.props.closeModal()}>Hecho</BtnPrimary>
        </div>
      </div>
    )
  }
}

export default ShareGroup
